export class ResponseWrapper<T> {
  public RootResults: T[];
  public TotalCount: number;
}
